// Update log
// FB  8099   01/17/2024  SK   Add Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
export default function ThankYou(){
    return(
        <div style={{textAlign:"center",margin:"20%",fontWeight:"bold"}}>
            Your Payment is Successfull. Thank You
        </div>
    )
}